import React from 'react';
import { useRowDensity } from '../../../../hook/useRowDensity';
import { formatNumberWithSpace } from '../../../../util/format-number';
import { StatsTableColumn } from '../../../../enum/TableColumn';
import { getCellClass } from '../../../../util/table-helper';

interface TableBodyProps {
  column: string;
  data: Record<string, number>[];
}

const TableBody: React.FC<TableBodyProps> = ({ data, column }) => {
  const { rowDensityClass } = useRowDensity();

  return (
    <div className="table_body">
      {data.map((row, index) => (
        <div
          key={index}
          className={`table_row ${
            column === StatsTableColumn.CCY || typeof row[column] === 'number' ? 'text_right' : ''
          } ${getCellClass(column, row)}`}
        >
          <div className={`table_cell ${rowDensityClass}`}>
            {typeof row[column] === 'number' ? formatNumberWithSpace(row[column]) : row[column]}
          </div>
        </div>
      ))}
    </div>
  );
};
export default TableBody;
